import api from './client';

// Reports API
export const reportsAPI = {
  getMonthly: (params) => api.get('/reports/monthly', { params }),
  getMonthDetail: (year, month, params) => api.get(`/reports/monthly/${year}/${month}`, { params }),
  getConsolidated: (params) => api.get('/reports/consolidated', { params }),
  // Tax paid to tax offices, line by line (same total as /reports/monthly tax_paid).
  getTaxPaid: (params) => api.get('/reports/tax-paid', { params }),
  brosDashboard: (period = 'ytd') => api.get('/reports/bros/dashboard', { params: { period } }),
  // Per-booking month shares + revenue invoice keys: the P&L/Cashflow
  // Bookings and Invoices lists group by due date from this (Fan, 2026-10-28).
  brosDashboardDrill: () => api.get('/reports/bros/dashboard', { params: { period: 'all', include_bookings: true }, timeout: 120000 }),
  brosCashflow: (period = 'ytd') => api.get('/reports/bros/dashboard/cashflow', { params: { period } }),
  brosHeatmaps: (period = 'ytd', dimension = 'client') => api.get('/reports/bros/dashboard/heatmaps', { params: { period, dimension } }),
  brosSales: (period = 'ytd') => api.get('/reports/bros/sales', { params: { period } }),
  brosBillingVsSales: (period = 'ytd', currency = 'gbp') => api.get('/admin/bros/dashboard/billing-vs-sales', { params: { period, currency } }),
  brosBookingInvoiceRecon: (period = 'ytd', currency = 'gbp') => api.get('/admin/bros/booking-invoice-reconciliation', { params: { period, currency } }),
  brosBookingInvoiceReconDrilldown: (params) => api.get('/admin/bros/booking-invoice-reconciliation/drilldown', { params }),
  getCashflowAnalysis: (year) => api.get('/reports/cashflow-analysis', { params: year ? { year } : {}, timeout: 120000 }),
  getMonthlyFinancials: (month) => api.get('/reports/monthly-financials', { params: month ? { month } : {}, timeout: 120000 }),
  getMonthlyFinancialsMonths: () => api.get('/reports/monthly-financials/months'),
  downloadMonthlyFinancialsPdf: (month) =>
    api.get('/reports/monthly-financials/pdf', { params: { month }, responseType: 'blob', timeout: 180000 }),
  getEntityPnl: (params) => api.get('/reports/entity-pnl', { params }),
  getCashDevelopment: (months = 12) => api.get('/reports/group/cash-development', { params: { months } }),
  getGroupBankBalanceSeries: (displayCurrency = 'GBP') =>
    api.get('/reports/group/bank-balance-series', { params: { display_currency: displayCurrency } }),
};
